module.exports = __webpack_public_path__ + "static/media/trust-wallet.77470bf5.png";